module.exports = __webpack_public_path__ + "static/sports3-b49dadd2ac9acce2091803c600339170.gif";